<template>
    <section>
        <div class="top-option-block">
            <router-link to="/customer" class="link">กลับไปหน้าค้นหา</router-link>
        </div>
    </section>
</template>

<script>
export default {
}
</script>